export const PROCESS_SEND_REFERRAL_START: string = 'PROCESS_SEND_REFERRAL_START'
export const PROCESS_SEND_REFERRAL_SUCCESS: string = 'PROCESS_SEND_REFERRAL_SUCCESS'
export const PROCESS_SEND_REFERRAL_FAIL: string = 'PROCESS_SEND_REFERRAL_FAIL'
